import {useState} from 'react';
import './App.css';
import {Grid} from "./Grid";
// import {ThreeByThreeGrid} from "./ThreeByThreeGrid";
// import {Cube} from "./Cube";

let onCellClaimed;

function App() {
    const [gridSliderVal, setGridSliderVal] = useState(3);
    const [gridSize, setGridSize] = useState(3);
    const [cellSize, setCellSize] = useState(10);
    const [squares, setSquares] = useState(true);
    const [picking, setPicking] = useState('red');
    const [hoveredCell, setHoveredCell] = useState(null);
    // for demo
    // const [page, setPage] = useState('game');

    const foo = (coords, claimedBy) =>
        onCellClaimed && onCellClaimed(coords, claimedBy);

    const commit = () => {
        foo(hoveredCell, picking);
        setHoveredCell(null)
    }


    // const renderNavButton = (key) => (
    //         <div className={`navButton${key === page ? ' active' : ''}`}
    //              onClick={() => setPage(key)}
    //         >
    //             {key}
    //         </div>
    // )

    // const renderNav = () => (
    //     <div className="nav">
    //         {renderNavButton('cube')}
    //         {renderNavButton('3x3')}
    //         {renderNavButton('game')}
    //     </div>
    // )

    const renderGridSizeInput = () => {
        console.log(window.location.pathname === '/experimental');
        return window.location.pathname === '/experimental' ? (
            <div className="gridSizeInput text">
                <p>Grid size: </p>
                <input
                    type="number"
                    defaultValue={gridSliderVal}
                    onChange={e => setGridSliderVal(e.target.value)}
                    onKeyDown={e =>
                        e.keyCode === 13 && setGridSize(gridSliderVal)
                    }
                />
                <button
                    className={`gridSizeInputSubmitButton`}
                    onClick={() => setGridSize(gridSliderVal)}
                >
                    <svg className={'checkBox'} xmlns="http://www.w3.org/2000/svg" height="23" viewBox="2 2 20 20"
                         width="23">
                        <path
                            d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                        />
                    </svg>
                </button>
            </div>

        ) : (
            <div className="gridSizeInput">
                <p>Grid size: {gridSliderVal}</p>
                <input
                    type="range"
                    defaultValue={gridSliderVal}
                    min={3}
                    max={6}
                    onChange={e => setGridSliderVal(e.target.value)}
                    onTouchEnd={e => setGridSize(e.target.value)}
                    onMouseUp={e => setGridSize(e.target.value)}
                />
            </div>
        );
    }

    const renderControls = () => (
        <div className="controls">
            {renderGridSizeInput()}
            <div className="squareCheck">
                <label htmlFor="foo">
                    Boxes
                    <input
                        id="foo"
                        type="checkbox"
                        checked={squares}
                        onChange={() => {
                            setSquares(!squares)
                        }}
                    />
                </label>
            </div>
            <div className="cellSizeSlider">
                <p>Cell size: {cellSize}</p>
                <input
                    type="range"
                    defaultValue={cellSize}
                    min={4}
                    max={14}
                    onChange={e => setCellSize(e.target.value)}
                />
            </div>
        </div>
    )

    const renderPickingIndicator = () => (
        <div className="pickingWrapper">
            <div className={`picking ${picking} ${squares ? '' : ' round'}`}/>
        </div>
    )

    const renderSubmitButton = () => {
        const disabled = !hoveredCell;
        return (
            <div className="submitButtonWrapper">
                <div
                    className={`submitButton ${disabled && 'disabled'}`}
                    onClick={() => disabled || commit()}
                >
                    <svg className={'checkBox'} xmlns="http://www.w3.org/2000/svg" height="35" viewBox="0 0 24 24"
                         width="35">
                        <path
                            d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                        />
                    </svg>
                </div>
            </div>
        )
    }

    // const renderCube = () => (<Cube/>)
    // const renderThreeByThree = () => (<ThreeByThreeGrid/>)
    const renderFull = () => (
        <>
            {renderControls()}
            {renderPickingIndicator()}
            <Grid
                key={`${gridSize}`}
                gridSize={gridSize}
                squaresProp={squares}
                cellSizeProp={cellSize / 10}
                pickingProp={picking}
                setPicking={setPicking}
                setOnCellClaimed={func => onCellClaimed = func}
                onCellClick={coords => setHoveredCell(coords)}
            />
            {renderSubmitButton()}
        </>
    )

    // const conditionalRender = () =>  page === 'cube' ? renderCube() :
    //         page === '3x3' ? renderThreeByThree() :
    //             renderFull()

    return (
        <div className="App">
            {/*{renderNav()}*/}
            {/*{conditionalRender()}*/}
            {renderFull()}
        </div>
    );
}

export default App;
